/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseListDictionaryClass } from '../../models/api-response-list-dictionary-class';

export interface ListsByClass$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  lang: string;
      body: Array<string>
}

export function listsByClass(http: HttpClient, rootUrl: string, params: ListsByClass$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListDictionaryClass>> {
  const rb = new RequestBuilder(rootUrl, listsByClass.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.query('lang', params.lang, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseListDictionaryClass>;
    })
  );
}

listsByClass.PATH = '/v1/api/dictionaries/list';
